import { useMemo } from 'react';
import useSearch from './use-search';
import { deEnum as rewriteFuel } from '../../../helpers/rewriteFuel';

const sortMakeByCount = ['true', true].includes(process.env.GATSBY_SORT_MAKE_FACET_BY_COUNT);

const sortString = (a, b) => a.fieldValue.localeCompare(b.fieldValue);
const sortCount = (a, b) => (a.totalCount > b.totalCount ? -1 : 1);
const sortInt = (a, b) => b.fieldValue - a.fieldValue;
const map = ({ fieldValue, totalCount }) => ({
  name: fieldValue,
  count: totalCount,
});

const getData = (groupedOptions) => {
  if ((groupedOptions || []).length > 0) {
    return {
      makeModels: groupedOptions.find(({ field }) => field === 'make')?.groups, // models is included
      bodies: groupedOptions.find(({ field }) => field === 'body')?.groups,
      fuels: groupedOptions.find(({ field }) => field === 'fuel')?.groups,
      transmissions: groupedOptions.find(({ field }) => field === 'transmission')?.groups,
      taxTypes: groupedOptions.find(({ field }) => field === 'taxType')?.groups,
      buildyears: groupedOptions.find(({ field }) => field === 'buildyear')?.groups,
      // colors:
      baseColors: groupedOptions.find(({ field }) => field === 'baseColor')?.groups,
      energylabels: groupedOptions.find(({ field }) => field === 'energylabel')?.groups,
      maxTowings: groupedOptions.find(({ field }) => field === 'maxTowing')?.groups,
      vehicleTypes: groupedOptions.find(({ field }) => field === 'vehicleType')?.groups,
      isNewVehicles: groupedOptions.find(({ field }) => field === 'isNewVehicle')?.groups,
      companies: groupedOptions.find(({ field }) => field === 'company.name')?.groups,
      seats: groupedOptions.find(({ field }) => field === 'seats')?.groups,
      doors: groupedOptions.find(({ field }) => field === 'doors')?.groups,
      taxAdditions: groupedOptions.find(({ field }) => field === 'taxAddition')?.groups,
      ranges: groupedOptions.find(({ field }) => field === 'range')?.groups,
      electricRanges: groupedOptions.find(({ field }) => field === 'electricRange')?.groups,
      powerHps: groupedOptions.find(({ field }) => field === 'powerHp')?.groups,
    };
  }

  console.warn('[vehicles use-filters] received no groupedOptions!');
  return {};
};

export default () => {
  const {
    groupedOptions,
    where,
    defaultWhere,
  } = useSearch();
  const selectedMake = where.make || defaultWhere.make;
  const {
    makeModels = [],
    bodies = [],
    fuels = [],
    transmissions = [],
    taxTypes = [],
    buildyears = [],
    colors = [],
    baseColors = [],
    energylabels = [],
    maxTowings = [],
    vehicleTypes = [],
    isNewVehicles = [],
    companies = [],
    seats = [],
    doors = [],
    taxAdditions = [],
    ranges = [],
    electricRanges = [],
    powerHps = [],
  } = getData(groupedOptions);

  return useMemo(() => {
    // convert possible String to Array
    const selectedMakes = [
      ...(Array.isArray(selectedMake) ? selectedMake : [selectedMake].filter(Boolean)),
    ];

    // we dont support models for multiple makes, so > 1
    const modelsForSelectedMake = selectedMakes.length === 0 || selectedMakes.length > 1
      ? []
      : (makeModels.find(({
        fieldValue,
      }) => selectedMakes.includes(fieldValue))?.models ?? []);

    return {
      allMakes: makeModels.sort(sortMakeByCount ? sortCount : sortString).map(map),
      modelsForSelectedMake: modelsForSelectedMake.sort(sortString).map(map),
      bodies: bodies.sort(sortString).map(map),
      fuels: fuels.sort(sortString).map(map).map((f) => ({
        ...f,
        value: f.name,
        name: rewriteFuel(f.name),
      })),
      transmissions: transmissions.sort(sortString).map(map),
      taxTypes: taxTypes.sort(sortString).map(map),
      buildyears: buildyears.sort(sortInt).map(map),
      colors: colors.sort(sortString).map(map),
      baseColors: baseColors.sort(sortString).map(map),
      energylabels: energylabels.sort(sortString).map(map),
      maxTowings: maxTowings.sort(sortInt).map(map).map((item) => ({
        ...item,
        value: item.name,
        name: `${item.name} kg`,
      })),
      vehicleTypes: vehicleTypes.sort(sortString).map(map),
      isNewVehicles: isNewVehicles.map(map),
      companies: companies.sort(sortString).map(map),
      seats: seats.sort(sortString).map(map),
      doors: doors.sort(sortString).map(map),
      taxAdditions: taxAdditions.sort(sortInt).map(map),
      ranges: ranges.sort(sortInt).map(map),
      electricRanges: electricRanges.sort(sortInt).map(map),
      powerHps: powerHps.sort(sortInt).map(map),
    };
  }, [
    selectedMake,
    makeModels,
    bodies,
    fuels,
    transmissions,
    taxTypes,
    buildyears,
    colors,
    baseColors,
    energylabels,
    maxTowings,
    vehicleTypes,
    isNewVehicles,
    companies,
    seats,
    doors,
    taxAdditions,
    ranges,
    electricRanges,
    powerHps,
  ]);
};
